import Vue from 'vue'
import { decode, parsePath, withoutBase, withoutTrailingSlash, normalizeURL } from 'ufo'

import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, urlJoin, sanitizeComponent } from './utils'
import NuxtError from '../layouts/error.vue'
import NuxtLoading from '~/components/admin/Loading/PageLoading'

import '../node_modules/font-awesome/css/font-awesome.min.css'

import '../node_modules/simple-line-icons/css/simple-line-icons.css'

import '../static/frontend/css/line-awesome.min.css'

const _4b4f74de = () => import('../layouts/admin/auth.vue'  /* webpackChunkName: "layouts/admin/auth" */).then(m => sanitizeComponent(m.default || m))
const _760f6b4b = () => import('../layouts/admin/default.vue'  /* webpackChunkName: "layouts/admin/default" */).then(m => sanitizeComponent(m.default || m))
const _4b54ac95 = () => import('../layouts/admin/menu.js'  /* webpackChunkName: "layouts/admin/menu" */).then(m => sanitizeComponent(m.default || m))
const _378cb5f2 = () => import('../layouts/frontend/approval-checkback-owner.vue'  /* webpackChunkName: "layouts/frontend/approval-checkback-owner" */).then(m => sanitizeComponent(m.default || m))
const _6871cf68 = () => import('../layouts/frontend/approval-checkback.vue'  /* webpackChunkName: "layouts/frontend/approval-checkback" */).then(m => sanitizeComponent(m.default || m))
const _0879e72c = () => import('../layouts/frontend/approval.vue'  /* webpackChunkName: "layouts/frontend/approval" */).then(m => sanitizeComponent(m.default || m))
const _2e2aa162 = () => import('../layouts/frontend/auth.vue'  /* webpackChunkName: "layouts/frontend/auth" */).then(m => sanitizeComponent(m.default || m))
const _49254f3a = () => import('../layouts/frontend/default.vue'  /* webpackChunkName: "layouts/frontend/default" */).then(m => sanitizeComponent(m.default || m))
const _2c50bfc4 = () => import('../layouts/frontend/lp-create.vue'  /* webpackChunkName: "layouts/frontend/lp-create" */).then(m => sanitizeComponent(m.default || m))
const _534172bf = () => import('../layouts/frontend/lp-minimal.vue'  /* webpackChunkName: "layouts/frontend/lp-minimal" */).then(m => sanitizeComponent(m.default || m))
const _6b5ae25e = () => import('../layouts/frontend/lp-sub.vue'  /* webpackChunkName: "layouts/frontend/lp-sub" */).then(m => sanitizeComponent(m.default || m))
const _6b5ae573 = () => import('../layouts/frontend/lp-top.vue'  /* webpackChunkName: "layouts/frontend/lp-top" */).then(m => sanitizeComponent(m.default || m))
const _2d431ceb = () => import('../layouts/frontend/lp.vue'  /* webpackChunkName: "layouts/frontend/lp" */).then(m => sanitizeComponent(m.default || m))
const _2e2031f4 = () => import('../layouts/frontend/menu.js'  /* webpackChunkName: "layouts/frontend/menu" */).then(m => sanitizeComponent(m.default || m))
const _8e16a922 = () => import('../layouts/frontend/no-layout.vue'  /* webpackChunkName: "layouts/frontend/no-layout" */).then(m => sanitizeComponent(m.default || m))
const _837df226 = () => import('../layouts/frontend/old.menu.js'  /* webpackChunkName: "layouts/frontend/old.menu" */).then(m => sanitizeComponent(m.default || m))
const _3562b318 = () => import('../layouts/frontend/share.vue'  /* webpackChunkName: "layouts/frontend/share" */).then(m => sanitizeComponent(m.default || m))
const _2d29e588 = () => import('../layouts/test.vue'  /* webpackChunkName: "layouts/test" */).then(m => sanitizeComponent(m.default || m))
const _6f6c098b = () => import('./layouts/default.vue'  /* webpackChunkName: "layouts/default" */).then(m => sanitizeComponent(m.default || m))

let resolvedLayouts = {}
const layouts = { "_admin/auth": _4b4f74de,"_admin/default": _760f6b4b,"_admin/menu": _4b54ac95,"_frontend/approval-checkback-owner": _378cb5f2,"_frontend/approval-checkback": _6871cf68,"_frontend/approval": _0879e72c,"_frontend/auth": _2e2aa162,"_frontend/default": _49254f3a,"_frontend/lp-create": _2c50bfc4,"_frontend/lp-minimal": _534172bf,"_frontend/lp-sub": _6b5ae25e,"_frontend/lp-top": _6b5ae573,"_frontend/lp": _2d431ceb,"_frontend/menu": _2e2031f4,"_frontend/no-layout": _8e16a922,"_frontend/old.menu": _837df226,"_frontend/share": _3562b318,"_test": _2d29e588,"_default": _6f6c098b }

export default {
  render (h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })

    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [templateEl])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: '',

    nbFetching: 0
    }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    this.$root.$options.$nuxt = this

    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  async mounted () {
    this.$loading = this.$refs.loading
  },

  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline () {
      return !this.isOnline
    },

    isFetching () {
      return this.nbFetching > 0
    },
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }
      this.$loading.start()

      const promises = pages.map((page) => {
        const p = []

        // Old fetch
        if (page.$options.fetch && page.$options.fetch.length) {
          p.push(promisify(page.$options.fetch, this.context))
        }
        if (page.$fetch) {
          p.push(page.$fetch())
        } else {
          // Get all component instance to call $fetch
          for (const component of getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)) {
            p.push(component.$fetch())
          }
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        this.$loading.fail(error)
        globalHandleError(error)
        this.error(error)
      }
      this.$loading.finish()
    },
    async errorChanged () {
      if (this.nuxt.err) {
        if (this.$loading) {
          if (this.$loading.fail) {
            this.$loading.fail(this.nuxt.err)
          }
          if (this.$loading.finish) {
            this.$loading.finish()
          }
        }

        let errorLayout = (NuxtError.options || NuxtError).layout;

        if (typeof errorLayout === 'function') {
          errorLayout = errorLayout(this.context)
        }

        await this.loadLayout(errorLayout)

        this.setLayout(errorLayout)
      }
    },

    setLayout (layout) {
      if (!layout || !resolvedLayouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      let _layout = '_' + layout
      this.layout = resolvedLayouts[_layout]
      return this.layout
    },
    loadLayout (layout) {
      const undef = !layout
      const nonexistent = !(layouts['_' + layout] || resolvedLayouts['_' + layout])
      let _layout = '_' + ((undef || nonexistent) ? 'default' : layout)
      if (resolvedLayouts[_layout]) {
        return Promise.resolve(resolvedLayouts[_layout])
      }
      return layouts[_layout]()
        .then((Component) => {
          resolvedLayouts[_layout] = Component
          delete layouts[_layout]
          return resolvedLayouts[_layout]
        })
        .catch((e) => {
          if (this.$nuxt) {
            return this.$nuxt.error({ statusCode: 500, message: e.message })
          }
        })
    },
  },

  components: {
    NuxtLoading
  }
}
